import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
    root: {
        backgroundColor: "#fff",
        marginTop: "auto",
    },
    boxCommonLinks: {
        padding: theme.spacing(0, 0, 5),
    },
    boxPrivacyTermsLinks: {
        padding: theme.spacing(0, 5, 0),
        [theme.breakpoints.down("md")]: {
            justifyContent: "center",
            padding: theme.spacing(2, 0),
        },
    },
    boxCopyright: {
        [theme.breakpoints.down("md")]: {
            textAlign: "center",
        },
    },
    title: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#3c4858",
    },
    link: {
        fontSize: "14px",
        fontWeight: 300,
        color: "#3c4858",
    },
    linksBoxClasses: {
        [theme.breakpoints.down("md")]: {
            textAlign: "center",
        },
    },
    linkSpacing: {
        padding: theme.spacing(0, 0, 1),
    },
    linksPrivacyAndTerms: {
        textAlign: "right",
        [theme.breakpoints.down("md")]: {
            textAlign: "center",
        },
    },
    logo: {
        [theme.breakpoints.down("sm")]: {
            textAlign: "center",
        },
    },
}));
